import React, { useEffect, useState } from "react";
import Layout from "../../../components/layout/layout";
import "./devListing.css";
import Filter from "../../../components/listing/filter";
import SearchListing from "../../../components/listing/search";
import CategoryListing from "../../../components/listing/category";
import DevProfile from "../../../components/listing/devprofile";
import ListingPagination from "../../../components/listing/pagination";
import { withoutAuthInstance } from "../../../config/axios";

const DevListingPage = () => {
  const [developerData, setDeveloperData] = useState([]);
  const getAllDeveloper = async () => {
    try {
      const res = await withoutAuthInstance.get(
        "/developer/get-public-developer-list"
      );
      const { data } = res;
      if (res?.status === 200) {
        if (data.length > 0) {
          setDeveloperData(data);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };
  console.log("developerData---->", developerData);
  useEffect(() => {
    getAllDeveloper();
  }, []);
  return (
    <Layout>
      <div className="container">
        <div className="dev-listing-page">
          <div className="dev-listing-left">
            <div className="candidate-count">
              <h5>
                Candidates:<span>{developerData?.length}</span>
              </h5>
            </div>
            <Filter />
          </div>
          <div className="dev-listing-right">
            <div className="dev-listing-topbar">
              <SearchListing />
              <div className='mobile-view-candidate-count'>
                <h4>
                  Candidates: <span>7,84,512</span>
                </h4>
              </div>
              <CategoryListing />
            </div>
            <div className="">
              <DevProfile developerData={developerData} />
            </div>
            <ListingPagination />
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default DevListingPage;
